module.exports = __webpack_public_path__ + "static/media/modis2952.7541898a.jpg";